import Image from '@/components/Image'

const HomeCard = ({ step, title, description, imgSrc }) => (
  <div className="container flex flex-col items-center justify-center rounded-xl p-4 text-center shadow-[1px_3px_26px_3px_rgba(0,0,0,0.1)]">
    <div className="relative mb-4 h-auto w-auto overflow-hidden rounded-xl bg-clip-border">
      <Image
        className="h-40 w-40 object-cover"
        src={imgSrc ? imgSrc : ''}
        alt={'Immagine che rappresenta:' + title}
        height={40}
        width={40}
      />
    </div>

    <div className="mt-2 flex min-h-full w-full flex-col items-center text-center lg:mt-0 lg:h-72">
      <div className="flex-1">
        <p className="block text-5xl font-semibold text-secondary-400 dark:text-primary-400 md:text-5xl">
          {step}
        </p>
        <p className="block text-3xl font-semibold text-gray-800 dark:text-white">{title}</p>

        <p className="multiline-truncate prose mt-3 max-w-none text-2xl text-gray-800 dark:text-gray-400">
          {description}
        </p>
      </div>
    </div>
  </div>
)

export default HomeCard
